import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestLinkText, {
  LinkTextProps,
} from 'ext-ui/design-system/generated/latest/components/LinkText/LinkText'
import GeneratedLiveLinkText from 'ext-ui/design-system/generated/live/components/LinkText/LinkText'
import React, { ReactElement } from 'react'

function renderDesignSystemLinkText(
  Component: typeof GeneratedLiveLinkText,
  channel: 'live' | 'latest',
  props: LinkTextProps,
): ReactElement {
  return <Component {...props} data-design-system-channel={channel} />
}

function LiveLinkText(props: LinkTextProps): ReactElement {
  return renderDesignSystemLinkText(GeneratedLiveLinkText, 'live', props)
}

function LatestLinkText(props: LinkTextProps): ReactElement {
  return renderDesignSystemLinkText(GeneratedLatestLinkText, 'latest', props)
}

function LinkText(props: LinkTextProps): ReactElement {
  const ResolvedLinkText = useResolvedDesignSystemComponent(
    LiveLinkText,
    LatestLinkText,
  )

  return <ResolvedLinkText {...props} />
}

export default LinkText
export type { LinkTextProps }
